import { useEffect, useState } from 'react';
import { Icon } from '../../components/Icon';
import type { CatalogItem } from '../../domain/types';
import { useTranslation } from '../../i18n/react';
import { resourceCategoryLabel } from './categories';
import './resources.css';

export function ResourceCard({ item, saved, onToggleSaved }: { item: CatalogItem; saved: boolean; onToggleSaved: (id: string) => void }) {
  const tr = useTranslation();
  const [imageFailed, setImageFailed] = useState(false);
  useEffect(() => setImageFailed(false), [item.thumbnailUrl]);
  const title = item.managed ? item.title : tr(item.title);
  const summary = item.managed ? item.summary : tr(item.summary);
  return <article className={`resource-card${item.managed ? ' resource-card-managed' : ''}`} aria-label={title} data-resource-id={item.id} data-resource-category={item.resourceCategory ?? 'other'}>
    <div className="resource-card-cover">
      {item.thumbnailUrl && !imageFailed ? <img className="resource-card-thumbnail" src={item.thumbnailUrl} alt={title} loading="lazy" decoding="async" referrerPolicy="no-referrer" onError={() => setImageFailed(true)} /> : <div className="resource-card-image-fallback"><Icon name="image" size={30}/><span>{tr('Không tải được ảnh xem trước')}</span></div>}
      <button type="button" className="resource-card-save" aria-pressed={saved} onClick={() => onToggleSaved(item.id)} aria-label={item.managed ? `${tr(saved ? 'Bỏ lưu' : 'Lưu')} ${title}` : tr(saved ? `Bỏ lưu ${item.title}` : `Lưu ${item.title}`)}>
        <Icon name="bookmark" size={17} />
      </button>
    </div>
    <div className="resource-card-body">
      <span className="resource-card-category">{resourceCategoryLabel(item.resourceCategory)}</span>
      <h2 className="resource-card-title">{title}</h2>
      {summary && <p className="resource-card-summary">{summary}</p>}
      {item.managed && item.downloadUrl ? <div className="resource-card-download-area"><a className="resource-download-button" href={item.downloadUrl} target="_blank" rel="noopener noreferrer" referrerPolicy="no-referrer"><Icon name="external" size={15}/>{tr('Tải xuống')}</a></div> : <div className="resource-card-meta">{tr(item.meta) || tr(item.category)}</div>}
    </div>
  </article>;
}
